require.register("app/restaurant/analyse/export/PDFModal", function(exports, require, module){
  $0
  
});

